import { Fragment, h } from 'preact';
import s from "./content.module.css";
import {
    iconCategoryClose,
    iconExamsCovid,
    iconExamsLab,
    iconMenuArrow, iconTermClose,
    iconVaccines,
    menuFacebookLogo,
    menuInstagramLogo,
    menuLinkedinLogo,
    menuSpotifyLogo,
    menuTwitterLogo,
    menuYoutubeLogo
} from "../../../assets";
import {Link} from "preact-router/match";
import { useAppContext } from '../../../contexts';

const LINKS = [
    {
        id: 2,
        name: "Nossas unidades",
        href: "https://www.sabin.com.br/unidades/",
        blank: true
    },
    {
        id: 6,
        name: "Resultado de exames",
        href: "https://laudos.sabin.com.br/shift/lis/sabin/elis/gestao/sabin.portal.login.csp",
        blank: true
    },
    {
        id: 1,
        name: "Fale conosco",
        href: "/fale-conosco",
        blank: false
    },
    {
        id: 3,
        name: "Perguntas frequentes",
        href: "/perguntas-frequentes",
        blank: false
    },
    {
        id: 4,
        name: "Termo de consentimento",
        href: "/termos-de-uso",
        blank: false
    },
    // {
    //     id: 5,
    //     name: "Horário de atendimento drive-thru",
    //     href: "https://www.sabin.com.br/coronavirus#rd-section-kb9thj1q",
    //     blank: true
    // },
]

const Content = props => {
    // Destructured component props
    const {handleIntrinsicMenu} = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={"px-6 py-6 md:py-12 md:px-24 w-full h-full"}>
                <div className={s.container}>
                    <button
                        type={"button"}
                        className={"select-none w-full justify-end flex"}
                        onClick={() => handleIntrinsicMenu()}
                    >
                        <div className={`flex flex-row-reverse items-center w-max -mr-[10px]`}>
                            <img
                                src={iconTermClose}
                                className={`${s.closeIcon} dark:grayscale`}
                                alt={"Close icon"}
                            />
                            <p className={`font-museo ${s.closeText} ${highContrast ? "highTitleSecond" : ""}`}>
                                Fechar
                            </p>
                        </div>
                    </button>
                    <div className={"h-full w-full flex flex-col items-start justify-start md:mt-8 overflow-y-scroll discrete-scrollbar light-discrete-scrollbar"}>
                        <p className={`mb-5 ${s.innerTitle} text-sabin-red-default ${highContrast ? "highTitleSecond" : ""}`}>
                            Nossos serviços
                        </p>
                        <div className={`w-full flex flex-col gap-y-5 mb-6`}>
                            <Link
                                href={"/vacinas"}
                                className={`${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                onClick={() => handleIntrinsicMenu()}
                            >
                                {/*<img*/}
                                {/*    src={iconVaccines}*/}
                                {/*    alt={"Vaccines icon"}*/}
                                {/*    className={`dark:grayscale`}*/}
                                {/*/>*/}
                                <span className={s.pipe}>
                                    |
                                </span>
                                <span className={s.linkName}>
                                    Vacinas
                                </span>
                            </Link>
                            <Link
                                href={"/exames-laboratoriais"}
                                className={`${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                onClick={() => handleIntrinsicMenu()}
                            >
                                {/*<img*/}
                                {/*    src={iconExamsLab}*/}
                                {/*    alt={"Exams icon"}*/}
                                {/*    className={`dark:grayscale`}*/}
                                {/*/>*/}
                                <span className={s.pipe}>
                                    |
                                </span>
                                <span className={s.linkName}>
                                    Exames Laboratoriais
                                </span>
                            </Link>




                            <Link
                                href={"/check-ups"}
                                className={`${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                onClick={() => handleIntrinsicMenu()}
                            >
                                {/*<img*/}
                                {/*    src={iconExamsLab}*/}
                                {/*    alt={"Exams icon"}*/}
                                {/*    className={`dark:grayscale`}*/}
                                {/*/>*/}
                                <span className={s.pipe}>
                                    |
                                </span>
                                <span className={s.linkName}>
                                    Check-ups
                                </span>
                            </Link>
                            <Link
                                href={"/vacinas/vacinas-para-criancas"}
                                className={`${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                onClick={() => handleIntrinsicMenu()}
                            >
                                {/*<img*/}
                                {/*    src={iconExamsLab}*/}
                                {/*    alt={"Exams icon"}*/}
                                {/*    className={`dark:grayscale`}*/}
                                {/*/>*/}
                                <span className={s.pipe}>
                                    |
                                </span>
                                <span className={s.linkName}>
                                    Vacinas Infantis
                                </span>
                            </Link>
                            <Link
                                href={"/testes-geneticos"}
                                className={`${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                onClick={() => handleIntrinsicMenu()}
                            >
                                {/*<img*/}
                                {/*    src={iconExamsLab}*/}
                                {/*    alt={"Exams icon"}*/}
                                {/*    className={`dark:grayscale`}*/}
                                {/*/>*/}
                                <span className={s.pipe}>
                                    |
                                </span>
                                <span className={s.linkName}>
                                    Exames Genéticos
                                </span>
                            </Link>




                            <Link
                                href={"/exames-covid-19"}
                                className={`${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                onClick={() => handleIntrinsicMenu()}
                            >
                                {/*<img*/}
                                {/*    src={iconExamsCovid}*/}
                                {/*    alt={"Covid icon"}*/}
                                {/*    className={`dark:grayscale`}*/}
                                {/*/>*/}
                                <span className={s.pipe}>
                                    |
                                </span>
                                <span className={s.linkName}>
                                    Exames Covid-19
                                </span>
                            </Link>
                        </div>
                        <div className={"w-full flex flex-col gap-y-4 mb-10"}>
                            {LINKS.map(item => {
                                return !item.blank ? (
                                    <Link
                                        key={item.id}
                                        href={item.href}
                                        className={`gap-x-12 ${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`}
                                        onClick={() => handleIntrinsicMenu()}
                                    >
                                        <img
                                            src={iconMenuArrow}
                                            className={`${s.menuArrow} dark:grayscale`}
                                            alt={"Arrow icon"}
                                        />
                                        <span className={s.basicLinkName}>
                                            {item.name}
                                        </span>
                                    </Link>
                                ) : (
                                    <a key={item.id} href={item.href} className={`gap-x-12 ${s.link} ${highContrast ? "" : "hover:text-sabin-red-default"}`} target={"_blank"} rel="noreferrer">
                                        <img
                                            src={iconMenuArrow}
                                            className={`${s.menuArrow} dark:grayscale`}
                                            alt={"Arrow icon"}
                                        />
                                        <span className={s.basicLinkName}>
                                            {item.name}
                                        </span>
                                    </a>
                                )
                            })}
                        </div>
                        <div className={"w-full flex flex-col"}>
                            <p className={`mb-3 ${s.innerTitle} text-sabin-red-default ${highContrast ? "highTitleSecond" : ""}`}>
                                Nossas redes
                            </p>
                            <div className={"flex flex-row items-center justify-start gap-x-2.5 flex-nowrap"}>
                                <a href={"https://www.instagram.com/sabinbr_/"} target={"_blank"} className={`${highContrast ? "" : s.socialLink}`} rel="noreferrer">
                                    <img src={menuInstagramLogo} alt={"Instagram logo"} />
                                </a>
                                <a href={"https://www.facebook.com/sabindiagnosticoesaude"} target={"_blank"} className={`${highContrast ? "" : s.socialLink}`} rel="noreferrer">
                                    <img src={menuFacebookLogo} alt={"Facebook logo"} />
                                </a>
                                <a href={"https://www.linkedin.com/company/sabin-medicina-diagnostica/"} target={"_blank"} className={`${highContrast ? "" : s.socialLink}`} rel="noreferrer">
                                    <img src={menuLinkedinLogo} alt={"Linkedin logo"} />
                                </a>
                                <a href={"https://www.youtube.com/@sabinbr_"} target={"_blank"} className={`${highContrast ? "" : s.socialLink}`} rel="noreferrer">
                                    <img src={menuYoutubeLogo} alt={"Youtube logo"} />
                                </a>
                                <a href={"https://twitter.com/sabinbr_"} target={"_blank"} className={`${highContrast ? "" : s.socialLink}`} rel="noreferrer">
                                    <img src={menuTwitterLogo} alt={"Twitter logo"} />
                                </a>
                                <a href={"https://open.spotify.com/user/sabinmedicinadiagnostica?si=497268219a294de5"} target={"_blank"} className={`${highContrast ? "" : s.socialLink}`} rel="noreferrer">
                                    <img src={menuSpotifyLogo} alt={"Spotify logo"} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Content;
